import { getLocales } from 'assets/locales/Locale';
import { ClaimCreatorOptions } from 'models/enums/ClaimCreation';
import { usePublicCreateClaimProvider } from '../Hooks';
import { PublicCreateClaimNewRepairFacility } from './NewRepairFacility';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { orderBy } from 'lodash';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';

export default function PublicCreateClaimSubmissionDetails() {
  const { lang, translate } = getLocales();
  const { user, isDealer } = useAuthStore();
  const publicCreateClaim = usePublicCreateClaimProvider();

  const claimCreationOption = publicCreateClaim.form.data.claimCreationOption;

  const claimCreationOptions = (
    isDealer
      ? [ClaimCreatorOptions.DEALERSHIP]
      : user
        ? [ClaimCreatorOptions.DEALERSHIP, ClaimCreatorOptions.REPAIR_FACILITY]
        : [ClaimCreatorOptions.CUSTOMER, ClaimCreatorOptions.DEALERSHIP, ClaimCreatorOptions.REPAIR_FACILITY]
  ).map((it) => ({
    id: it,
    title: translate(it).replace(/_/g, ' '),
  }));

  return (
    <>
      <h2>{lang.claimSubmissionTitle}</h2>
      <p>{lang.claimSubmissionParagraph}.</p>

      <FormWrapper>
        <InputWrapper>
          <SelectInput
            name="claimCreationOption"
            label={lang.whoIsSubmittingTheClaim}
            error={publicCreateClaim.form.errors.claimCreationOption}
            placeholder={lang.whoIsSubmittingTheClaim}
            data={claimCreationOptions}
            disabled={claimCreationOptions.length === 0}
            value={publicCreateClaim.form.data.claimCreationOption}
            onChange={({ claimCreationOption }) => {
              publicCreateClaim.form.update({
                claimCreationOption,
                repairFacilityId: undefined,
                newPayee: null,
                claim: publicCreateClaim.getResetClaimData(),
              });
            }}
          />
          {claimCreationOption === ClaimCreatorOptions.REPAIR_FACILITY && (
            <SelectInput
              name="repairFacilityId"
              label={lang.repairFacility}
              error={publicCreateClaim.form.errors.repairFacilityId}
              value={publicCreateClaim.form.data.repairFacilityId}
              placeholder={lang.repairFacility}
              data={[
                {
                  id: null,
                  title: lang.addNew,
                },
                ...(publicCreateClaim.repairFacilityListApi.payload?.data?.map((it) => ({
                  id: it.id,
                  title: it.name,
                })) ?? []),
              ]}
              onChange={({ repairFacilityId }) => {
                publicCreateClaim.form.update({
                  repairFacilityId,
                  newPayee: !repairFacilityId ? {} : null,
                  claim: publicCreateClaim.getResetClaimData(),
                });
              }}
            />
          )}

          {claimCreationOption === ClaimCreatorOptions.DEALERSHIP && (
            <SelectInput
              name="dealerId"
              label={lang.dealership}
              error={publicCreateClaim.form.errors.claim?.dealerId}
              value={publicCreateClaim.form.data.claim?.dealerId}
              disabled={publicCreateClaim.dealerListPublicApi.payload?.data.length === 1}
              placeholder={lang.dealership}
              data={orderBy(
                publicCreateClaim.dealerListPublicApi.payload?.data?.map((it) => ({
                  id: it.id,
                  title: it.name,
                })),
                [
                  ({ title }) => {
                    const firstChar = title?.charAt(0) ?? '';

                    if (/[A-Za-z]/.test(firstChar)) return 1;
                    if (/[0-9]/.test(firstChar)) return 2;
                    return 3;
                  },
                  'Name',
                ],
                ['asc', 'asc']
              )}
              onChange={({ dealerId }) => {
                publicCreateClaim.form.update({
                  repairFacilityId: undefined,
                  claim: {
                    ...publicCreateClaim.getResetClaimData(),
                    dealerId,
                  },
                });
              }}
            />
          )}
        </InputWrapper>

        {publicCreateClaim.form.data.newPayee && <PublicCreateClaimNewRepairFacility />}
      </FormWrapper>
    </>
  );
}
